import type { ViewProps } from 'react-native'
import * as Comp from './popover-trigger.styles'

interface TPopoverTriggerProps extends ViewProps {}

export function PopoverTrigger({ children, ...rest }: TPopoverTriggerProps) {
  return <Comp.Trigger {...rest}>{children}</Comp.Trigger>
}
